<div class="overview_club" >

  <div class="session_proposed_by" > 
    <span>Session proposée par: </span>
    <span><strong>{{club.clubName}}</strong></span>
  </div>
  <div class="overview_club_content">
    <span>
      <fa-icon [icon]="getFaIcon('faPhone')" appChangeColorTheme attribute="color"></fa-icon>
      <a href="tel:{{club.phoneNumber}}">{{club.phoneNumber}}</a>
    </span>
    <span>
      <fa-icon [icon]="getFaIcon('faEnvelope')" appChangeColorTheme attribute="color"></fa-icon>
      <a href="mailto:{{club.mail}}">{{club.mail}}</a>

    </span>
  </div>


</div>